import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';

const DelayedContentContext = createContext(
  null
);
function DelayedContentContextProvider({
  children,
  delayTime,
  isShow,
  onStartLoading
}) {
  return /* @__PURE__ */ jsx(
    DelayedContentContext.Provider,
    {
      value: useMemo(
        () => ({ delayTime, isShow, onStartLoading }),
        [delayTime, isShow, onStartLoading]
      ),
      children
    }
  );
}
function useDelayedContentContext() {
  const context = useContext(DelayedContentContext);
  if (context === null) {
    throw new Error(
      `useDelayedContentContext\uB294 DelayedContentContextProvider\uB85C \uAC10\uC2F8\uC9C4 \uCEF4\uD3EC\uB10C\uD2B8\uC5D0\uC11C\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694.`
    );
  }
  return context;
}

export { DelayedContentContextProvider, useDelayedContentContext };
//# sourceMappingURL=context.mjs.map
